export const apiUrls = {
    mainURL: "https://api-blog.nifc.pl/",
    category: "category",
    posts: "posts",
    author: "authors",
    newsletter: "index.php/page/save_to_newsletter",
    sklep: "https://api-sklep.nifc.pl/newsletter/add",
};
